@if (isVisible) {
  <div class="dialog-overlay" (click)="closeDialog()" (keydown.escape)="closeDialog()">
    <div class="dialog-box" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h2 class="dialog-title">{{ 'CREATE_SPACE.TITLE' | translate }}</h2>
      <div class="dialog-body">
        <div class="form-group">
          <label class="form-label" for="spaceName">{{ 'CREATE_SPACE.NAME_LABEL' | translate }}</label>
          <div class="input-wrapper">
            <input
              type="text"
              id="spaceName"
              class="form-input"
              [placeholder]="'CREATE_SPACE.NAME_PLACEHOLDER' | translate"
              [(ngModel)]="spaceName"
            />
          </div>
          @if (errorMessage) {
            <div class="error-message">{{ errorMessage }}</div>
          }
        </div>
        <div class="form-group">
          <label class="form-label" for="country">{{ 'CREATE_SPACE.COUNTRY_LABEL' | translate }}</label>
          <div class="select-wrapper">
            <select id="country" class="form-select" [(ngModel)]="selectedCountry">
              @for (country of countries; track country) {
                <option [value]="country">{{ country }}</option>
              }
            </select>
          </div>
          <p class="country-helper">{{ 'CREATE_SPACE.COUNTRY_HELPER' | translate }}</p>
        </div>
      </div>
      <div class="dialog-actions">
        <button class="btn-save" (click)="createSpace()">{{ 'CREATE_SPACE.CREATE_BUTTON' | translate }}</button>
        <button class="btn-cancel" (click)="closeDialog()">{{ 'CREATE_SPACE.CANCEL' | translate }}</button>
      </div>
    </div>
  </div>
}
